import React from 'react';
import { Empty } from 'antd';
import { useDispatch } from 'react-redux';
import { CustomersByStation, FluxClientsFilters } from 'types';
import { isEspagne } from 'common/config/env';

import { customersListActions } from '../../../common/config/store';
import StyledTable from '../../organisms/styled-table';
import { useIntl } from '../../../common/config/i18n';
import { useColumns } from './use-table-columns';
import styles from './styles.module.css';
import PaginationBlock from 'components/molecules/pagination';

type Props = {
  data?: CustomersByStation;
  filterValues?: FluxClientsFilters;
};

const CustomersByStationList: React.FC<Props> = ({ data, filterValues }) => {
  const { t } = useIntl();
  const dispatch = useDispatch();

  const customersByStationColumns = useColumns()?.[isEspagne ? 'ES' : 'FR'];

  const customersByStationDataSource = data?.result
    ? data?.result?.map((item, index) => ({
        key: `${item.serviceName}-${index}`,
        ...item,
      }))
    : [];

  return (
    <>
      <PaginationBlock
        data={{ pageNumber: data?.pageNumber, maxPages: data?.maxPages, maxResultPage: data?.maxResultPage }}
        onChange={(page: number, pageSize?: number) =>
          dispatch(
            customersListActions.fetchCustomersByStation({
              ...filterValues,
              pageNumber: page,
              maxResultPage: pageSize,
            })
          )
        }
      />
      <StyledTable
        pagination={false}
        dataSource={customersByStationDataSource}
        columns={customersByStationColumns}
        padding="0"
        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('empty')} /> }}
        rowClassName={styles.fluxClientRowClassName}
        className={styles.tableClassName}
      />
      <PaginationBlock
        data={{ pageNumber: data?.pageNumber, maxPages: data?.maxPages, maxResultPage: data?.maxResultPage }}
        onChange={(page: number, pageSize?: number) =>
          dispatch(
            customersListActions.fetchCustomersByStation({
              ...filterValues,
              pageNumber: page,
              maxResultPage: pageSize,
            })
          )
        }
      />
    </>
  );
};

export default CustomersByStationList;
